<template>
  <document-container
    :header="header"
    :logo="logo"
    :tables="tables"
    :timeout="12000"
    documentType="equivalence-check"
  >

    <div
      v-for="productType in config"
      slot="raw-body"
      class="page-block"
    >
      <product-table
        :id="'product-table-' + productType.entityType"
        :table="tables.findTable('product-table-' + productType.entityType)"
      ></product-table>
    </div>

  </document-container>
</template>

<script>
import DocumentContainer from '../document/DocumentContainer'
import BlockMixin from '../block/BlockMixin'
import ProductTable from '../table/TableOnepagerProducts.vue'
import {Table,} from '../../model/table/Table'
import {TableCollection,} from '../../model/table/TableCollection'
import ProductService from "../../service/ProductService"
import TokenService from "../../service/TokenService"

export default {
  name: 'equivalence-check',

  data() {
    return {
      ProductTable,
      config: null,
      products: null,
      tables: {
        type: TableCollection,

      },
      token: null,
      watchlistName: null,
    }
  },

  props: {
    environment: {
      type: String,
      required: true,
    },
    watchlistId: {
      type: String,
      required: true,
    },
    ecId: {
      type: String,
      required: true,
    },
    appInstance: {
      type: String,
      required: false,
    },
  },

  methods: {
    fetchProducts() {
      ProductService.getEquivalenceCheck(
        this.environment,
        this.appInstance,
        this.watchlistId,
        this.ecId,
        this.token,
      ).then(productsResponse => {
        this.products = productsResponse.data.data.instrumentTypeProductMapping
        this.watchlistName = (productsResponse.data.data.watchlistLabel) + (productsResponse.data.data.areListsDifferent ? ' gegen ' + productsResponse.data.data.referenceListLabel : '')

        ProductService.getEquivalenceCheckStructure(
          this.environment,
          this.appInstance,
          this.watchlistId,
          this.ecId,
          this.token,
        ).then(structureResponse => {
          this.config = structureResponse.data.data.structures

          let productTables = []

          this.config.forEach(productType => {
            // define common fields
            let ecField = productType.columns.findIndex(el => el.path === 'enriched.equivalenceCheckResult.similarProducts')
            let commentField = productType.columns.findIndex(el => el.path === 'enriched.equivalenceCheckResult.comment')
            let costField = productType.columns.findIndex(el => el.path === 'derived.bison.costs')

            // add comment field to ec field
            productType.columns[ecField].decoratorOptions.componentOptions.fields.push({
              "label": "Kommentare",
              "info": null,
              "style": "italics",
              'newline': true,
              "path": "enriched.equivalenceCheckResult.similarProducts",
              "commentsPath": "enriched.equivalenceCheckResult.comments",
              "decorator": "text",
              "sortPath": null,
              "initialOrder": null,
              "weight": 12,
              "pathToStyleHints": null,
              "splitIndicator": "NONE"
            })

            // add config for skipped message (s. FieldComponent.vue)
            productType.columns[ecField].fallback = {
              "label": "Kommentare",
              "info": null,
              "style": "italics",
              "path": "enriched.equivalenceCheckResult.checkSkipped",
              "decorator": "text",
              "sortPath": null,
              "initialOrder": null,
              "weight": 12,
              "pathToStyleHints": null,
              "splitIndicator": "NONE"
            }

            // set weights
            productType.columns[0].weight = 1
            productType.columns[1].weight = 2

            if (costField !== -1) {
              productType.columns[costField].weight = 1
              productType.columns[ecField].weight = 7
            } else {
              productType.columns[ecField].weight = 8
            }

            // remove old comment field
            productType.columns.splice(commentField)

            productTables.push(new Table(
              'product-table-' + productType.entityType,
              productType.columns,
              this.products[productType.entityType],
              ProductTable,
              productType.heading,
            ))
          })

          this.tables = new TableCollection(...productTables)
        })

      })
    },
  },

  head: {
    link: function () {
      return [
        {
          rel: 'stylesheet',
          href: '/config/' + this.environment + '/style/equivalence_check.css',
        },
      ]
    },
  },

  mixins: [BlockMixin],

  async created() {
    if (this.$route.query.token) {
      this.token = this.$route.query.token
    } else {
      this.token = await TokenService.checkToken()
    }
    this.fetchProducts()
  },

  computed: {
    logo() {
      return '/config/' + this.environment + '/images/logo.png'
    },
    header() {
      return [{
        type: 'Pagetitle',
        title: 'Äquivalenzcheck - ' + this.watchlistName,
        position: 'header',
        sort: 1,
        shared: true,
      }]
    },
  },

  components: {
    DocumentContainer,
    ProductTable,
  },
}
</script>



// WEBPACK FOOTER //
// EquivalenceCheck.vue?1c197f89